module.exports = __webpack_public_path__ + "img/invisible.f22c631a.svg";